import { useCallback, useState } from 'react';

/**
 * Lightweight replacement for `@vueuse/core`'s `useClipboard`. Returns a
 * `copy` function plus a transient `copied` flag that flips back after `ttl`ms.
 */
export function useClipboard({ ttl = 1500 }: { ttl?: number } = {}) {
    const [copied, setCopied] = useState(false);

    const copy = useCallback(
        async (text: string) => {
            try {
                await navigator.clipboard.writeText(text);
                setCopied(true);
                window.setTimeout(() => setCopied(false), ttl);
                return true;
            } catch {
                return false;
            }
        },
        [ttl],
    );

    return { copy, copied };
}
